import {useEffect, useState} from 'react';
import {faker} from '@faker-js/faker';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router';
import {useSearchParams} from 'react-router-dom';
import {parseValidationErrors} from 'services/api/utils/parse-error';
import {selectUser} from 'store/auth/selectors';
import {
  StoreDirectoryRequest,
  useStoreDirectoryMutation,
} from 'store/directory/endpoints/store-directory';
import {Option} from 'types/option';
import {useSeeder} from 'utils/use-seeder';

const __DEV__ = process.env.NODE_ENV === 'development';

export default () => {
  const [send, {isLoading, error}] = useStoreDirectoryMutation();

  const serverError = parseValidationErrors(error);

  const fake = useSeeder();
  const asc = useSelector(selectUser);
  const refUser = {id: asc?.id, name: asc?.profile?.full_name} as Option;

  const [params, setParams] = useState<Params>({
    company_name: __DEV__ ? fake.companyName : '',
    phone: __DEV__ ? fake.phone() : '',
    categories: [],
    families: [],
    reference_contact: refUser,
    comment: __DEV__ ? fake.paragraph : '',
    email: __DEV__ ? fake.email : '',
    job: __DEV__ ? faker.name.jobTitle() : '',
    directory_type: 'COMPANY', //important to hardcode here to not create two endpoint files that do the same
  });

  const navigate = useNavigate();

  const [queryParameters] = useSearchParams();

  const company_name = queryParameters.get('newClient');

  useEffect(() => {
    if (company_name) {
      setParams({...params, company_name});
    }
  }, [company_name, setParams, params]);

  const handleSubmit = async () => {
    const result = await send(params);

    if ('data' in result) {
      const company = result?.data.data;
      navigate(`/dashboard/directories/${company.id}/general`);
    }
  };

  return {
    setParams,
    params,
    isLoading,
    validationErrors: serverError.errors,
    errorMessage: serverError.message,
    submit: handleSubmit,
  };
};

type Params = StoreDirectoryRequest;
